import { useQuery } from "@apollo/client";
import { CompanyDocumentReadConfirmationType } from "gql/graphql";
import { GET_COMPANY_DOCUMENT_READ_CONFIRMATION_TYPE } from "../api/get-company-document-read-confirmation-type";

export function useCompanyDocumentReadConfirmationType(id: string) {
  const { data } = useQuery(GET_COMPANY_DOCUMENT_READ_CONFIRMATION_TYPE, {
    variables: { id },
  });

  const readConfirmationType =
    data?.getCompanyDocumentById.readConfirmationType;

  return {
    readConfirmationType,
    canAssign:
      !!readConfirmationType &&
      readConfirmationType !== CompanyDocumentReadConfirmationType.NotRequired,
  };
}
